import React from 'react';
import _isNumber from 'lodash/isNumber';
import _memoize from 'lodash/memoize';
import { PropTypes as PT } from 'prop-types';
import Draggable from 'react-draggable';
import SVG from 'react-inlinesvg';
import turtleHoverIcon from '@lifesize/ux-assets/vectors/svgIcons/turtle-hover.svg';
import turtleNormalIcon from '@lifesize/ux-assets/vectors/svgIcons/turtle-normal.svg';
import classes from './Turtle.module.scss';

const TURTLE_DEFAULT_SIZE = 30;

class Turtle extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMouseOver: false
    };
  }

  /**
   * Uses default size of 30, unless different value specified in props
   * Font size is adjusted for padding automatically.
   * @return {{width: Number|number, height: Number|number, fontSize: string}}
   */
  getDefaultConfig = _memoize(() => {
    const TURTLE_SIZE = _isNumber(this.props.size) ? this.props.size : TURTLE_DEFAULT_SIZE;
    return {
      borderRadius: `${TURTLE_SIZE}px`,
      height: TURTLE_SIZE,
      width: TURTLE_SIZE
    };
  });

  /**
   * Exposes Draggable's onDrag event
   */
  handleDrag = (e, ui) => (this.props.handleDrag ? this.props.handleDrag(e, ui) : null);

  handleDragStart = () => this.props.turtleDragStart();

  handleDragStop = () => this.props.turtleDragStop();

  mouseOut = () => this.setState({ isMouseOver: false });

  mouseOver = () => this.setState({ isMouseOver: true });

  render() {
    const {
      videoLayout,
      turtlePosition,
      visible
    } = this.props;
    // Component not visible
    if (!visible) return <span />;

    const { leftBounds, rightBounds } = videoLayout;
    const bounds = { left: leftBounds, right: rightBounds };

    return (
      <Draggable
        axis="x"
        position={turtlePosition}
        bounds={{
          left: bounds.left,
          right: bounds.right
        }}
        onDrag={this.handleDrag}
        onStart={this.handleDragStart}
        onStop={this.handleDragStop}
      >
        <div
          className={classes.turtle}
          onMouseOut={() => this.mouseOut()}
          onMouseOver={() => this.mouseOver()}
          style={this.getDefaultConfig()}
          data-testid={(this.state.isMouseOver || this.props.isDragging) ? "turtleHoverIcon" : "turtleNormalIcon"}
        >
          {(this.state.isMouseOver || this.props.isDragging)
            ? <SVG src={turtleHoverIcon} />
            : <SVG src={turtleNormalIcon} />
          }
        </div>
      </Draggable>
    );
  }
}

Turtle.propTypes = {
  handleDrag: PT.func,
  isDragging: PT.bool,
  size: PT.number,
  turtleDragStart: PT.func,
  turtleDragStop: PT.func,
  turtlePosition: PT.object,
  videoLayout: PT.object,
  visible: PT.bool
};

Turtle.defaultProps = {
  visible: true,
  turtlePosition: { x: 0, y: 0 },
  videoLayout: { leftBounds: 0, rightBounds: 0 },
  size: TURTLE_DEFAULT_SIZE
};

export default Turtle;
